import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export const ACTION_TYPE = {
  CLIENT_FOLLOW_UP: {
    key: 2,
    label: "Client Follow Up",
    access: "onCase.client",
    icon: {
      color: HNSColors.primary[500],
      label: SvgEnum.HisPerson,
    },
  },
  LAW_FIRM_FOLLOW_UP: {
    key: 3,
    label: "Law Firm Follow Up",
    access: "onFirm",
    icon: {
      color: HNSColors.tertiary[300],
      label: SvgEnum.HisLandmark,
    },
  },
  PROVIDER_FOLLOW_UP: {
    key: 4,
    label: "Provider Follow Up",
    access: "onProvider",
    icon: {
      color: HNSColors.success[400],
      label: SvgEnum.HisStethoscope,
    },
  },
};

export const ACTION_TYPE_MAPPING = {
  2: ACTION_TYPE.CLIENT_FOLLOW_UP,
  3: ACTION_TYPE.LAW_FIRM_FOLLOW_UP,
  4: ACTION_TYPE.PROVIDER_FOLLOW_UP,
};
